import axios from '../helpers/axiosConfig';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

function Decoration() {
  const [listedeco, setListDeco] = useState([]);
  const [decorations, setDecorations] = useState([]);
  const [selectedDecoration, setSelectedDecoration] = useState('');
  const [eligiblePersonnels, setEligiblePersonnels] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Récupérer les décorations lors du montage du composant
    const fetchDecorations = async () => {
      try {
        const response = await axios.get('/decoration');
        setDecorations(response.data);
        setListDeco(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des décorations:', error);
      }
    };
    fetchDecorations();
  }, []);

  const handleDecorationChange = async (event) => {
    const decorationId = event.target.value;
    setSelectedDecoration(decorationId);
    setEligiblePersonnels([]);

    if (decorationId) {
      setLoading(true);
      toast.warn('Veuillez patienter pour lister les personnels éligibles');
      try {
        const response = await axios.get('/personnel/api/x/eligible-decorations', {
          params: { decorationId },
        });
        setEligiblePersonnels(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des personnels éligibles:', error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="min-h-screen bg-gray-950 pt-16 px-4 pb-8">
      <div className="max-w-6xl mx-auto space-y-6">

        {/* ── Section : personnels éligibles ── */}
        <div className="bg-gray-900 border border-gray-700 rounded-2xl p-6">

          <h2 className="text-lg font-semibold text-white mb-1">
            Personnels éligibles à une décoration
          </h2>
          <p className="text-sm text-gray-400 mb-5">
            Sélectionnez une décoration pour afficher la liste des personnels éligibles
          </p>

          {/* Select décoration */}
          <div className="relative">
            <i className="fa fa-award absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none"></i>
            <select
              value={selectedDecoration}
              onChange={handleDecorationChange}
              className="w-full bg-gray-800 border border-gray-600 text-white text-sm rounded-xl pl-9 pr-4 py-2.5 appearance-none focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-500/20 transition-all cursor-pointer"
            >
              <option value="">-- Sélectionnez une décoration --</option>
              {decorations.map((decoration) => (
                <option key={decoration.id} value={decoration.id}>
                  {decoration.name}
                </option>
              ))}
            </select>
            <i className="fa fa-chevron-down absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-xs pointer-events-none"></i>
          </div>

          {/* Badge résultats */}
          {selectedDecoration && (
            <div className="inline-flex items-center gap-2 mt-4 px-3 py-1.5 bg-gray-800 border border-gray-700 rounded-lg text-sm text-gray-400">
              <i className="fa fa-users text-green-400 text-xs"></i>
              Résultats trouvés :
              <span className="font-semibold text-white">{eligiblePersonnels.length}</span>
            </div>
          )}

          {/* Spinner loading */}
          {loading && (
            <div className="flex items-center gap-2 mt-5 text-sm text-gray-400">
              <i className="fa fa-spinner fa-spin text-green-400"></i>
              Chargement en cours...
            </div>
          )}

          {/* Tableau personnels éligibles */}
          {!loading && eligiblePersonnels.length > 0 && (
            <div className="overflow-x-auto mt-5">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-gray-800">
                    <th className="text-left px-4 py-3 text-xs font-medium text-gray-400 border-b border-gray-700 rounded-tl-lg">Grade</th>
                    <th className="text-left px-4 py-3 text-xs font-medium text-gray-400 border-b border-gray-700">Nom et prénoms</th>
                    <th className="text-left px-4 py-3 text-xs font-medium text-gray-400 border-b border-gray-700">Date de naissance</th>
                    <th className="text-left px-4 py-3 text-xs font-medium text-gray-400 border-b border-gray-700">Date de recrutement</th>
                    <th className="text-left px-4 py-3 text-xs font-medium text-gray-400 border-b border-gray-700 rounded-tr-lg">Décoration éligible</th>
                  </tr>
                </thead>
                <tbody>
                  {eligiblePersonnels.map((personnel) => (
                    <tr key={personnel.personnelId} className="border-b border-gray-800 hover:bg-gray-800/50 transition-colors">
                      <td className="px-4 py-3 text-gray-300">{personnel.personnelGrade}</td>
                      <td className="px-4 py-3 text-white font-medium">{personnel.personnelName}</td>
                      <td className="px-4 py-3 text-gray-300">{personnel.personnelDatenaisse}</td>
                      <td className="px-4 py-3 text-gray-300">{personnel.personnelDaterecrute}</td>
                      <td className="px-4 py-3">
                        <span className="inline-block px-2.5 py-1 text-xs font-medium bg-green-900/40 text-green-300 border border-green-700/40 rounded-full">
                          {personnel.decorationEligible}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* État vide après sélection */}
          {!loading && selectedDecoration && eligiblePersonnels.length === 0 && (
            <div className="flex flex-col items-center justify-center mt-8 py-6 text-gray-500">
              <i className="fa fa-inbox text-3xl mb-2 text-gray-600"></i>
              <p className="text-sm">Aucun personnel éligible pour cette décoration</p>
            </div>
          )}
        </div>

        {/* ── Section : liste des décorations ── */}
        <div className="bg-gray-900 border border-gray-700 rounded-2xl p-6">

          <div className="flex items-center justify-between mb-5">
            <div className="flex items-center gap-2">
              <i className="fa fa-certificate text-green-400 text-lg"></i>
              <h2 className="text-lg font-semibold text-white">Liste des décorations</h2>
            </div>
            <Link
              to="/creatdecoration"
              className="flex items-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-xl transition-colors duration-200"
            >
              <i className="fa fa-plus text-xs"></i>
              Nouvelle décoration
            </Link>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-gray-800">
                  <th className="text-left px-4 py-3 text-xs font-medium text-gray-400 border-b border-gray-700">Décoration</th>
                  <th className="text-left px-4 py-3 text-xs font-medium text-gray-400 border-b border-gray-700">Libellé</th>
                  <th className="text-left px-4 py-3 text-xs font-medium text-gray-400 border-b border-gray-700">Âge requis</th>
                  <th className="text-left px-4 py-3 text-xs font-medium text-gray-400 border-b border-gray-700">Années de service</th>
                </tr>
              </thead>
              <tbody>
                {listedeco.length === 0 ? (
                  <tr>
                    <td colSpan={4} className="text-center py-8 text-gray-500 text-sm">
                      <i className="fa fa-inbox text-2xl block mb-2 text-gray-600"></i>
                      Aucune décoration enregistrée
                    </td>
                  </tr>
                ) : (
                  listedeco.map((item, key) => (
                    <tr key={key} className="border-b border-gray-800 hover:bg-gray-800/50 transition-colors last:border-b-0">
                      <td className="px-4 py-3 text-white font-medium">{item.name}</td>
                      <td className="px-4 py-3 text-gray-300">{item.libelle}</td>
                      <td className="px-4 py-3 text-gray-300">{item.age} ans</td>
                      <td className="px-4 py-3 text-gray-300">{item.anneedeservice} ans</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Decoration;